const dmGrid = document.querySelector('.dm-event-results');

dmGrid?.addEventListener('click', danceMarathonGaEvents);

function danceMarathonGaEvents(event) {
  const { target } = event;

  if (target.id === 'register-link') {
    ga('send', 'event', 'Dance Marathon', 'Register', target.dataset.dmName);
  } else if (target.id === 'donation-link') {
    ga('send', 'event', 'Dance Marathon', 'Donate', target.dataset.dmName);
  }
}
